import * as React from 'react'
import { Check } from 'lucide-react'
import { cn } from '~/lib/utils'

// KRDS form-chip — 다중선택 필터 칩(체크박스 의미). 토글하면 add/remove로 동작한다.
//  · 선택: border-primary + bg-accent + text-accent-foreground, 좌측 체크(14px)
//  · 미선택: border-input + bg-card + text-foreground, hover bg-secondary
// height ~36px, radius 6px, px 12px, font 14px, 1px border. count는 우측 muted 숫자.
export type FormChipProps = Omit<
    React.ComponentProps<'button'>,
    'onToggle' | 'children'
> & {
    selected: boolean
    onToggle: () => void
    children: React.ReactNode
    count?: number
}

function FormChip({
    selected,
    onToggle,
    children,
    count,
    className,
    ...props
}: FormChipProps) {
    return (
        <button
            type='button'
            role='checkbox'
            aria-checked={selected}
            aria-pressed={selected}
            onClick={onToggle}
            className={cn(
                'inline-flex h-7 items-center gap-1 rounded-[var(--radius)] border px-2.5 text-[12px] font-medium transition-colors outline-none',
                'focus-visible:ring-ring/40 focus-visible:border-primary focus-visible:ring-2',
                selected
                    ? 'border-primary bg-accent text-accent-foreground'
                    : 'border-border bg-card text-foreground hover:bg-secondary hover:text-foreground',
                className
            )}
            {...props}>
            {selected ? (
                <Check aria-hidden className='size-3 shrink-0' />
            ) : null}
            <span className='truncate'>{children}</span>
            {count !== undefined ? (
                <span className='tnum text-muted-foreground ml-0.5 text-[11px]'>
                    {count}
                </span>
            ) : null}
        </button>
    )
}

export { FormChip }
